module.exports = __webpack_public_path__ + "img/2.b01925b9.png";